import { useEffect } from "react";
import { Input, Radio } from "@gamesb42/ui-kit";

import { corparateDoc } from "./index";
import { observer } from "mobx-react";
import UploadFile from "components/UploadFile";

import { ReactComponent as Pdf } from "./assets/pdf.svg";
import { ReactComponent as Close } from "./assets/close.svg";

import s from "./styles.module.scss";
import { authorizedRequest } from "utils/authorization";
import FileName from "./components/FileName";

const Step5 = observer(() => {
  useEffect(() => {
    const conditionForUpload =
      corparateDoc.values.step5Variant === "upload" &&
      corparateDoc.values.certificateOfGoodStandingFile!.name.length > 0;
    const conditionForNotApplicable =
      corparateDoc.values.step5Variant === "notApplicable" &&
      corparateDoc.values.certificateOfGoodStandingComment.length > 0;

    if (conditionForUpload || conditionForNotApplicable) {
      corparateDoc.isStepIsValid[5] = true;
    } else {
      corparateDoc.isStepIsValid[5] = false;
    }
  }, [
    corparateDoc.values.step5Variant,
    corparateDoc.values.certificateOfGoodStandingComment,
    corparateDoc.values.certificateOfGoodStandingFile!.name,
  ]);

  function delFileHandler() {
    if (corparateDoc.values.certificateOfGoodStandingFile?.docId?.length > 0) {
      corparateDoc.values.needtoDelete.push(
        corparateDoc.values.certificateOfGoodStandingFile.docId
      );
    }

    corparateDoc.values.certificateOfGoodStandingFile = {
      id: "",
      docId: "",
      name: "",
      value: "",
      size: 0,
    };

    corparateDoc.values.certificateOfGoodStandingComment = "";
  }

  return (
    <>
      <p>Certificate of Good Standing or equivalent*</p>
      <Radio.Group value={corparateDoc.values.step5Variant}>
        <Radio
          value="upload"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step5Variant = "upload";
          }}
        >
          Upload
        </Radio>
        <Radio
          value="notApplicable"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step5Variant = "notApplicable";
          }}
        >
          Not applicable
        </Radio>
      </Radio.Group>
      {corparateDoc.values.step5Variant === "upload" && (
        <div
          style={{
            marginTop: "32px",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div className={s.uploadHolder}>
            {(corparateDoc.values.certificateOfGoodStandingFile!.size === 0 && (
              <UploadFile
                dragText="Drag and drop file*"
                uploadText={`50 Mb max. weight`}
                onUpload={(e, file) => {
                  corparateDoc.values.certificateOfGoodStandingFile!.name =
                    file.name;
                  corparateDoc.values.certificateOfGoodStandingFile!.size =
                    file.size;
                  corparateDoc.values.certificateOfGoodStandingFile!.value =
                    file;
                }}
              />
            )) || (
              <FileName
                fileName="certificateOfGoodStandingFile"
                clearFiles={delFileHandler}
              />
            )}
          </div>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Comment to the uploaded file"
            disabled={
              corparateDoc.values.certificateOfGoodStandingFile?.docId?.length >
              0
            }
            showCount={true}
            maxLength={200}
            value={corparateDoc.values.certificateOfGoodStandingComment}
            onChange={(e) => {
              corparateDoc.values.certificateOfGoodStandingComment =
                e.target.value;
            }}
          />
        </div>
      )}

      {corparateDoc.values.step5Variant === "notApplicable" && (
        <div style={{ padding: "32px 0 0 0" }}>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Not applicable? Please explain why*"
            disabled={false}
            showCount={true}
            maxLength={200}
            value={corparateDoc.values.certificateOfGoodStandingComment}
            onChange={(e) => {
              corparateDoc.values.certificateOfGoodStandingComment =
                e.target.value;
            }}
            placeholder="Not applicable? Please explain why*"
          />
        </div>
      )}
    </>
  );
});

export default Step5;
